import * as gs from "@ivanlog/gs";
import { CmpInputTokenAmountBase } from "./tmpls";
import { BiMath } from "../libs/BiMath";

export class CmpInputTokenAmount extends CmpInputTokenAmountBase {

    private _onChangeValue:gs.EventGS<bigint>;
    private _onChangeValueToken:gs.EventGSToken<bigint>;

    constructor() {
        super();
        this._onChangeValueToken = new gs.EventGSToken<bigint>();
        this._onChangeValue = new gs.EventGS(this._onChangeValueToken);
        let cacheValue = BiMath.Zero;
        this.ctrls.iValue.el.addEventListener('input',async ()=>{
            let value = this._clearValueFunc(this.ctrls.iValue.value);
            if (value===false) {this.ctrls.iValue.value = BiMath.ToEth(cacheValue); return;}
            cacheValue = BiMath.ToBI(value);
            this._onChangeValueToken.invoke(cacheValue);
        });
    }

    public get onChangeValue() {return this._onChangeValue;}

    public setToken(tokenSymbol:string, tokenAdr:string)
    {
        this.ctrls.lTokenName.text = tokenSymbol;
        this.ctrls.imgIcon.src="files/images/erc20/"+tokenAdr.toLowerCase()+".webp";
    }

    public setValueBI(value:bigint)
    {
        let str = BiMath.ToEth(value);
        let i = str.indexOf('.');
        if (i<19) i = 19;
        str = str.slice(0, i);
        this.ctrls.iValue.value = str;
    }

    private _clearValueFunc(value:string){         
        if (value=="") return value;
        if (value.charAt(0)==".")value="0"+value;
        const regex = /^[0-9]+(\.[0-9]{0,18})?$/;
        if (!regex.test(value)) return false;                
        return value;
    }
}